// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__VFps8","ranges":"BmiRanges_ranges__17iz4"};